import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { routeAnimations } from '../../../core/animations/route.animations';
import { QuillEditorComponent } from 'ngx-quill';

import 'quill-mention';

@Component({
  selector: 'anms-light-post',
  templateUrl: './light-post.component.html',
  styleUrls: ['./light-post.component.scss'],
  animations: [routeAnimations],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class LightPostComponent implements OnInit {
  @ViewChild(QuillEditorComponent, { static: true })
  editor: QuillEditorComponent;

  content = '';
  matContent = '';

  modules = {};

  toolbarOptions = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['link', 'image', 'video'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    [{ font: [] }],
    ['clean']
  ];

  constructor() {
    this.modules = {
      mention: {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        onSelect: (item, insertItem) => {
          const editor = this.editor.quillEditor;
          insertItem(item);
          // necessary because quill-mention triggers changes as 'api' instead of 'user'
          editor.insertText(editor.getLength() - 1, '', 'user');
        },
        source: (searchTerm, renderList) => {
          const values = [
            { id: 1, value: 'Fredrik Sundqvist' },
            { id: 2, value: 'Patrik Sjölin' }
          ];

          if (searchTerm.length === 0) {
            renderList(values, searchTerm);
          } else {
            const matches = [];

            values.forEach(entry => {
              if (
                entry.value.toLowerCase().indexOf(searchTerm.toLowerCase()) !==
                -1
              ) {
                matches.push(entry);
              }
            });
            renderList(matches, searchTerm);
          }
        }
      },
      toolbar: this.toolbarOptions
    };
  }

  ngOnInit(): void {}
}
